// extracted by mini-css-extract-plugin
export default {"container":"About_container__bAb3d","faqItemList":"About_faqItemList__r7jhf","roadmapContainer":"About_roadmapContainer__aquGF","roadmapTitle":"About_roadmapTitle__49HRM"};